import _ from 'lodash';
import { ApiFactory } from './ApiClient';

const API = ApiFactory.create();

const testData = [
    [
        {
        "data": {
            "center_octave": null,
            "metronome_marking": null,
            "metronome_marking_factory": null,
            "notes": "G maj",
            "rhytmic_motif": null,
            "time_resolution": null,
            "time_signature": null,
            "tonality": null,
            "tonality_factory": null
        },
        "length": 4,
        "start_at": 0
        },
        {
        "data": {
            "center_octave": null,
            "metronome_marking": null,
            "metronome_marking_factory": null,
            "notes": "D maj",
            "rhytmic_motif": 'abcde fgh ik',
            "time_resolution": null,
            "time_signature": null,
            "tonality": null,
            "tonality_factory": null
        },
        "length": 4,
        "start_at": 4.0
        },
        {
        "data": {
            "center_octave": null,
            "metronome_marking": null,
            "metronome_marking_factory": null,
            "notes": "G maj",
            "rhytmic_motif": null,
            "time_resolution": null,
            "time_signature": null,
            "tonality": null,
            "tonality_factory": null
        },
        "length": 8,
        "start_at": 8.0
        },
        {
        "data": {
            "center_octave": null,
            "metronome_marking": null,
            "metronome_marking_factory": null,
            "notes": "C maj",
            "rhytmic_motif": 'Lorem ipsum dolor sit amet',
            "time_resolution": null,
            "time_signature": 'consectetur adipiscing elit',
            "tonality": null,
            "tonality_factory": null
        },
        "length": 8,
        "start_at": 16.0
        },
        {
        "data": {
            "center_octave": null,
            "metronome_marking": null,
            "metronome_marking_factory": null,
            "notes": "D maj",
            "rhytmic_motif": null,
            "time_resolution": null,
            "time_signature": null,
            "tonality": null,
            "tonality_factory": null
        },
        "length": 8,
        "start_at": 24.0
        }
    ],
    [{
        "data": {
            "center_octave": null,
            "metronome_marking": 'foo',
            "metronome_marking_factory": null,
            "notes": "Ab min",
            "rhytmic_motif": null,
            "time_resolution": null,
            "time_signature": null,
            "tonality": null,
            "tonality_factory": null
        },
        "length": 8,
        "start_at": 16.0
        },]
  ];

  const pianoRollHNG = {
      "resolution": "EIGHTH",
      "notes": [
          [
              {
                  "note_group": [
                      57,
                      61,
                      64
                  ],
                  "duration": "EIGHTH"
              }
          ],
          [
              {
                  "note_group": [
                      59,
                      62,
                      66
                  ],
                  "duration": "EIGHTH"
              }
          ],
          [
              {
                  "note_group": [
                      61,
                      64,
                      68
                  ],
                  "duration": "EIGHTH"
              }
          ],
          [
              {
                  "note_group": [
                      62,
                      66,
                      69
                  ],
                  "duration": "EIGHTH"
              }
          ],
          [
              {
                  "note_group": [
                      64,
                      68,
                      71
                  ],
                  "duration": "EIGHTH"
              }
          ],
          [
              {
                  "note_group": [
                      66,
                      69,
                      73
                  ],
                  "duration": "EIGHTH"
              }
          ],
          [
              {
                  "note_group": [
                      68,
                      71,
                      74
                  ],
                  "duration": "EIGHTH"
              }
          ],
          []
      ],
      "length": 8
  };

/*
  const pianoRoll = {
      length: 8,
      noteGroups: [
          { at: 0, notes: [57, 61, 64], duration: new NoteDuration(32) },
          { at: 1, notes: [59, 62, 66], duration: new NoteDuration(32) },
          { at: 2, notes: [61, 64, 68], duration: new NoteDuration(32) },
          { at: 3, notes: [62, 66, 69], duration: new NoteDuration(32) },
          { at: 4, notes: [64, 68, 71], duration: new NoteDuration(32) },
          { at: 5, notes: [66, 69, 73], duration: new NoteDuration(32) },
          { at: 6, notes: [68, 71, 74], duration: new NoteDuration(32) }
      ]
  };
*/

const weihnachtsBaeckerei = [
    [
        {
            "resolution": "HALF",
            "notes": [
                [
                    {
                        "chord": {
                            "type": "concrete",
                            "chord": "G",
                            "family": "maj"
                        },
                        "duration": "HALF"
                    }
                ]
            ],
            "length": 1,
            "type": "chordSpec"
        },
        {
            "resolution": "EIGHTH",
            "notes": [
                [
                    {
                        "note_group": [
                            59
                        ],
                        "duration": "QUARTER"
                    }
                ],
                [],
                [
                    {
                        "note_group": [
                            59
                        ],
                        "duration": "QUARTER"
                    }
                ],
                []
            ],
            "length": 4,
            "type": "noteGroup"
        },
        {"complement": ['G', 'D']}
    ],
    [
        {
            "resolution": "HALF",
            "notes": [
                [
                    {
                        "chord": {
                            "type": "concrete",
                            "chord": "D",
                            "family": "maj"
                        },
                        "duration": "HALF"
                    }
                ]
            ],
            "length": 1,
            "type": "chordSpec"
        },
        {
            "resolution": "EIGHTH",
            "notes": [
                [
                    {
                        "note_group": [
                            57
                        ],
                        "duration": "QUARTER"
                    }
                ],
                [],
                [
                    {
                        "note_group": [
                            57
                        ],
                        "duration": "QUARTER"
                    }
                ],
                []
            ],
            "length": 4,
            "type": "noteGroup"
        },
        {"complement": ['D', 'F#']}
    ],
    [
        {
            "resolution": "WHOLE",
            "notes": [
                [
                    {
                        "chord": {
                            "type": "concrete",
                            "chord": "G",
                            "family": "maj"
                        },
                        "duration": "WHOLE"
                    }
                ]
            ],
            "length": 1,
            "type": "chordSpec"
        },
        {
            "resolution": "EIGHTH",
            "notes": [
                [
                    {
                        "note_group": [
                            55
                        ],
                        "duration": "DOTTED_HALF"
                    }
                ],
                [],
                [],
                [],
                [],
                [],
                [
                    {
                        "note_group": [
                            57
                        ],
                        "duration": "EIGHTH"
                    }
                ],
                [
                    {
                        "note_group": [
                            59
                        ],
                        "duration": "EIGHTH"
                    }
                ]
            ],
            "length": 8,
            "type": "noteGroup"
        },
        {"complement": ['D']}
    ],
    [
        {
            "resolution": "WHOLE",
            "notes": [
                [
                    {
                        "chord": {
                            "type": "concrete",
                            "chord": "C",
                            "family": "maj"
                        },
                        "duration": "WHOLE"
                    }
                ]
            ],
            "length": 1,
            "type": "chordSpec"
        },
        {
            "resolution": "EIGHTH",
            "notes": [
                [
                    {
                        "note_group": [
                            60
                        ],
                        "duration": "QUARTER"
                    }
                ],
                [],
                [
                    {
                        "note_group": [
                            60
                        ],
                        "duration": "QUARTER"
                    }
                ],
                [],
                [
                    {
                        "note_group": [
                            59
                        ],
                        "duration": "QUARTER"
                    }
                ],
                [],
                [
                    {
                        "note_group": [
                            59
                        ],
                        "duration": "QUARTER"
                    }
                ],
                []
            ],
            "length": 8,
            "type": "noteGroup"
        },
        {"complement": ['E', 'G']}
    ],
    [
        {
            "resolution": "WHOLE",
            "notes": [
                [
                    {
                        "chord": {
                            "type": "concrete",
                            "chord": "D",
                            "family": "maj"
                        },
                        "duration": "WHOLE"
                    }
                ]
            ],
            "length": 1,
            "type": "chordSpec"
        },
        {
            "resolution": "EIGHTH",
            "notes": [
                [
                    {
                        "note_group": [
                            57
                        ],
                        "duration": "DOTTED_HALF"
                    }
                ],
                [],
                [],
                [],
                [],
                [],
                [
                    {
                        "note_group": [
                            57
                        ],
                        "duration": "EIGHTH"
                    }
                ],
                [
                    {
                        "note_group": [
                            59
                        ],
                        "duration": "EIGHTH"
                    }
                ]
            ],
            "length": 8,
            "type": "noteGroup"
        },
        {"complement": ['D', 'F#']}
    ]
];


const weihnachtsBaeckereiUnified = [
    {
        "resolution": "EIGHTH",
        "notes": [
            [
                {
                    "chord": {
                        "type": "concrete",
                        "chord": "G",
                        "family": "maj"
                    },
                    "duration": "HALF"
                }
            ],
            [],
            [],
            [],
            [
                {
                    "chord": {
                        "type": "concrete",
                        "chord": "D",
                        "family": "maj"
                    },
                    "duration": "HALF"
                }
            ],
            [],
            [],
            [],
            [
                {
                    "chord": {
                        "type": "concrete",
                        "chord": "G",
                        "family": "maj"
                    },
                    "duration": "WHOLE"
                }
            ],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [
                {
                    "chord": {
                        "type": "concrete",
                        "chord": "C",
                        "family": "maj"
                    },
                    "duration": "WHOLE"
                }
            ],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [
                {
                    "chord": {
                        "type": "concrete",
                        "chord": "D",
                        "family": "maj"
                    },
                    "duration": "WHOLE"
                }
            ],
            [],
            [],
            [],
            [],
            [],
            [],
            []
        ],
        "length": 32,
        "type": "chordSpec"
    },
    {
        "resolution": "EIGHTH",
        "notes": [
            [
                {
                    "note_group": [
                        59
                    ],
                    "duration": "QUARTER"
                }
            ],
            [],
            [
                {
                    "note_group": [
                        59
                    ],
                    "duration": "QUARTER"
                }
            ],
            [],
            [
                {
                    "note_group": [
                        57
                    ],
                    "duration": "QUARTER"
                }
            ],
            [],
            [
                {
                    "note_group": [
                        57
                    ],
                    "duration": "QUARTER"
                }
            ],
            [],
            [
                {
                    "note_group": [
                        55
                    ],
                    "duration": "DOTTED_HALF"
                }
            ],
            [],
            [],
            [],
            [],
            [],
            [
                {
                    "note_group": [
                        57
                    ],
                    "duration": "EIGHTH"
                }
            ],
            [
                {
                    "note_group": [
                        59
                    ],
                    "duration": "EIGHTH"
                }
            ],
            [
                {
                    "note_group": [
                        60
                    ],
                    "duration": "QUARTER"
                }
            ],
            [],
            [
                {
                    "note_group": [
                        60
                    ],
                    "duration": "QUARTER"
                }
            ],
            [],
            [
                {
                    "note_group": [
                        59
                    ],
                    "duration": "QUARTER"
                }
            ],
            [],
            [
                {
                    "note_group": [
                        59
                    ],
                    "duration": "QUARTER"
                }
            ],
            [],
            [
                {
                    "note_group": [
                        57
                    ],
                    "duration": "DOTTED_HALF"
                }
            ],
            [],
            [],
            [],
            [],
            [],
            [
                {
                    "note_group": [
                        57
                    ],
                    "duration": "EIGHTH"
                }
            ],
            [
                {
                    "note_group": [
                        59
                    ],
                    "duration": "EIGHTH"
                }
            ]
        ],
        "length": 32,
        "type": "noteGroup"
    }
];

const randomColor = () => {
    let c = '#' + Math.floor(Math.random()*16777215).toString(16);
    // console.log('color', c);
    return c;
}

const convertCtxToComponentModel = (ctx) => {
    let width = _(ctx).map((row) => {
        return row.map((item) => {
            return item.length + item.start_at;
        })}).flatten().sortBy((i) => i).reverse().first();
    let height = ctx.length;

    // console.log('width x length', width, height);

    let data = _.range(height).map(() => _.range(width).map(() => null));
    _.each(ctx, (row, rowIdx) => {
        _.each(row, (item) => {
            item.outlineColor = randomColor();
            item.gridId = "grid-" + _.uniqueId();

            _.range(item.length).forEach((i) => {
                data[rowIdx][item.start_at + i] = {...item, isEnd: false, isStart: i === 0};
            });
            data[rowIdx][item.start_at + item.length - 1].isEnd = true;
        });
    });

    return data;

}

const convertPianoRollToComponentModel = (pr) => {
    let notes = _.range(pr.length).map(() => []);
    _.each(pr.noteGroups, (noteGroup) => {
        notes[noteGroup.at] = noteGroup;
    });
    return notes;
}



export {convertCtxToComponentModel, convertPianoRollToComponentModel};
export {testData, pianoRollHNG, weihnachtsBaeckerei, weihnachtsBaeckereiUnified};